import HBSelect from "../../HBInput/select";
/**
 * 分类下拉框
 * @param {*} props
 */
export default function CategoriesSelect({ categories, ...props }) {
  const filterOption = (value, option) => {
    return option.label?.includes(value);
  };
  return (
    <HBSelect
      {...props}
      placeholder="分类"
      showSearch
      allowClear
      options={categories.map((item) => ({ label: item.name, ...item }))}
      filterOption={filterOption}
    />
  );
}
